module finadai.app {
  export var NAME = 'finadai.app';
  function AppController($scope, $rootScope, $document, appConfig, $state: ng.ui.IStateService, $mdSidenav, $mdComponentRegistry, whoIAm, negotiationStatus){
    $scope.pageTransitionOpts = appConfig.pageTransitionOpts;
    $rootScope.app = appConfig.app;
    $rootScope.negotiationStatus = negotiationStatus;
    $scope.color = appConfig.color;
    $rootScope.loggedUser = whoIAm;

    // Checks if the given state is the current state
    $scope.is = name => $state.is(name);

    // Checks if the given state/child states are present
    $scope.includes = name => $state.includes(name);

    // 
    $rootScope.$on("$stateChangeSuccess", function (event, currentRoute, previousRoute) {
      $document.duScrollTo(0, 0);
    });

    // for mdSideNav right
    $scope.toggleRight = buildToggler('right');
    $scope.isOpenRight = function() {
      if ( !$mdComponentRegistry.get('right') ) return;

      return $mdSidenav('right').isOpen();
    };

    function buildToggler(navID) {
      return function() {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID).toggle();
      }
    }
  }
  function appConfig() {
    var pageTransitionOpts = [
      {
          name: 'Fade up',
          "class": 'animate-fade-up'
      }, {
          name: 'Scale up',
          "class": 'ainmate-scale-up'
      }, {
          name: 'Slide in from right',
          "class": 'ainmate-slide-in-right'
      }, {
          name: 'Flip Y',
          "class": 'animate-flip-y'
      }
    ];
    var date = new Date();
    var year = date.getFullYear();
    var app = {
      brand: 'Quam',
      user: 'Jane',
      year: year,
      pageTransition: pageTransitionOpts[0],          // 0, 1, 2, 3... and build your own
      layoutBoxed: false,                             // true, false
      navCollapsed: false,                            // true, false
      navBehind: false,                               // true, false
      fixedHeader: true,                              // true, false
      sidebarWidth: 'middle',                         // small, middle, large      
      theme: 'light',                                 // light, gray, dark
      colorOption: '21',                               // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
      link: 'http://www.quam.mx/',
      phone: '01 (800) 123 4567'
    };
    var color = {
      primary:    'rgba(33,150,243,.7)', // #2196F3
      success:    'rgba(102,187,106,.7)', // #66BB6A
      info:       'rgba(0,188,212,.7)', // #00BCD4
      infoAlt:    'rgba(126,87,194,.7)', // #7E57C2
      warning:    'rgba(255,202,40,.7)', // #FFCA28
      danger:     'rgba(233,75,59,.7)', // #E94B3B
      gray:       '#EF5350'
    };

    return {
      pageTransitionOpts: pageTransitionOpts,
      app: app,
      color: color
    }
  }

  function mdConfig($mdThemingProvider: ng.material.IThemingProvider) {
    var cyanAlt = $mdThemingProvider.extendPalette('cyan', {
        'contrastLightColors': '500 600 700 800 900',
        // 'contrastStrongLightColors': '500 600 700 800 900'
    })
    var greenAlt = $mdThemingProvider.extendPalette('green', {
        'contrastLightColors': '400 500 600 700 800 900',
        // 'contrastStrongLightColors': '400 500 600 700 800 900'
    })        

    $mdThemingProvider
        .definePalette('cyanAlt', cyanAlt)
        .definePalette('greenAlt', greenAlt);


    $mdThemingProvider.theme('default')
        .primaryPalette('blue', {
            'default': '500'
        })
        .accentPalette('greenAlt', {
            'default': '400'
        })
        .warnPalette('red', {
            'default': '400'
        })
        .backgroundPalette('grey');
  }

  function HeaderController($scope, authService: finadai.services.AuthService, $state: ng.ui.IStateService, customersService: services.CustomersService, $rootScope: ng.IRootScopeService){
    $scope.pendingNegotiations = [];
    $scope.logout = () => {
      authService.logout().then(response => { $state.go('login') });
    }
    function updatePendingNegotiations(){
      if(authService.currentUser.privilege == 'customer'){
        customersService.getPendingNegotiations().then(response => {
          $scope.pendingNegotiations = response.data.data;
        });
      }
    }
    // updatePendingNegotiations();
    
    $rootScope.$on('updatePendingNegotiations', updatePendingNegotiations)
  }
  export function run(){
    var app = angular.module(NAME, [
      'ui.router',
      'ngAnimate',
      'ngAria',
      'ngMessages',
      'ngSanitize',

      // 3rd Party Modules
      'oc.lazyLoad',
      'ngMaterial',
      'md.data.table',
      'duScroll',
      'finadai.theme',
      'angularFileUpload',
      finadai.lang.NAME,
      finadai.config.NAME,
      finadai.app.dashboard.NAME,
      finadai.app.forgotPassword.NAME,
      finadai.app.changePassword.NAME,
      finadai.app.register.NAME,
      finadai.app.login.NAME,
      finadai.app.findYourCredit.NAME,
      finadai.app.payYourCredit.NAME,
      finadai.app.upload.NAME,
      finadai.filters.NAME,
      finadai.directives.NAME,
      finadai.services.NAME,
      finadai.app.search.NAME,
      finadai.app.negotiations.NAME,
      finadai.app.payments.NAME,
      finadai.app.activities.NAME,
      finadai.app.granters.NAME,
      finadai.app.agents.NAME,
      finadai.app.customers.NAME,
      finadai.app.customers.cancel_negotiation.NAME,
      finadai.app.admin.NAME,
      finadai.app.admin.create.NAME,
      finadai.app.admin.search.NAME,
      finadai.app.admin.find.NAME,
      finadai.app.admin.create_reference.NAME,
      finadai.app.admin.change_sic.NAME,
      finadai.app.admin.cancel_negotiation.NAME,
      finadai.app.admin.update.NAME
    ]);
    app.factory('appConfig', appConfig);
    app.config(mdConfig);
    app.controller('AppController', AppController)
    app.controller('HeaderController', HeaderController)
    app.constant('negotiationStatus', { new: 'Nueva', pending: 'Pendiente', complete: 'Completada', cancelled: 'Cancelada', paid: 'Pagada'})
  }
}
finadai.app.run();
